// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function dareClear(): ReducerAction {
	return {
		type: Types.DARE_CLEAR,
		payload: null,
	};
}
